import styled from "styled-components";

import { SPACING } from "../../utils/constants";
import { BaseButton } from "../Button";

export const SegmentedTrack = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs}px;
  padding: ${SPACING.xs}px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--color-text-muted) 8%, transparent);
  border: 1px solid var(--color-card-border);
`;

export const SegmentButton = styled(BaseButton)<{ $active: boolean }>`
  justify-content: center;
  appearance: none;
  border: none;
  cursor: pointer;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  font-weight: 600;
  padding: ${SPACING.xs}px ${SPACING.md}px;
  border-radius: 999px;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
  background: ${({ $active }) =>
    $active ? "var(--color-card-background)" : "transparent"};
  color: ${({ $active }) =>
    $active ? "var(--color-text-default)" : "var(--color-text-secondary)"};
  box-shadow: ${({ $active }) => ($active ? "var(--shadow-small)" : "none")};

  &:hover {
    color: var(--color-text-default);
  }
`;
